@if(downloadAllowed || reorder || chartId() || overlayOptions().length) {
<div class="mb-4 flex justify-end items-center">
  @if (downloadAllowed) {
    <p-menu #downloadmenu [model]="downloadMenuItems" [popup]="true" appendTo="body" baseZIndex="99999"/>
    <button pButton outlined="true" (click)="downloadmenu.toggle($event)" pTooltip="Descargar datos">
      <i class="fa-solid fa-download"></i>
    </button>
  }

  @if (reorder && chartData.datasets.length > 1) {
    <button pButton class="ms-2" outlined="true" (click)="reorderDatasets()" pTooltip="Invertir orden datasets">
      <i class="fa-solid fa-shuffle"></i>
    </button>
  }

  @if (overlayOptions().length) {
    <p-menu #overlaymenu [model]="overlayMenuItems()" [popup]="true" appendTo="body" baseZIndex="99999"/>
    <button pButton class="ms-2" [outlined]="!overlayKey()" (click)="overlaymenu.toggle($event)" [pTooltip]="overlayTooltip">
      <i class="fa-solid fa-layer-group"></i>
    </button>
  }

  @if (chartId(); as id) {
    <cosmos-chart-options-button
      class="ms-2"
      [chartId]="id"
      [hasBands]="!!thresholdBands()?.bands?.length"
      [sameOriginAllowed]="sameOriginAllowed"
      [overlayKey]="overlayKey()"
      [primaryAxisText]="primaryAxisText"
      [overlayAxisText]="overlayAxisText"
      (overlayAxisChange)="onOverlayAxisChange($event)"
      (configChange)="onChartOptionsChange($event)"
    />
  }
</div>
}

<cosmos-chart-legend [items]="legendItems" (toggle)="onLegendToggle($event)" />

<div class="chart-wrapper">
  <canvas #myChart [id]="'comparechart-'+dataset" baseChart style="width:100%;height:100%;"
    [data]="chartData"
    [options]="chartOptions"
    [legend]="false"
    [plugins]="chartPlugins"
    [type]="chartType"></canvas>
</div>

@if (rangeSelector()) {
  <div class="navigator-wrapper">
    <canvas baseChart
      [data]="navigatorChartData"
      [options]="navigatorChartOptions"
      [plugins]="navigatorPlugins"
      type="line"></canvas>
  </div>
}
